import * as React from 'react'
import { connect } from 'react-redux'

import { DropdownItem } from 'embed/constants'
import { configStateSelector } from 'embed/selectors/config'
import { ConfigServiceDataKeys } from 'even-ts-static'
import Select from 'react-select'

export interface OwnProps {
  optionValuesConfigKey: ConfigServiceDataKeys
  optionBoundingSet: DropdownItem<unknown>[]
}

export interface StoreProps {
  items?: DropdownItem<unknown>[]
}

type Props = OwnProps & StoreProps

const DynamicSelect: React.FC<Props> = (props) => (
  // We're temporarily disabling searchability for all FormDropdown components because of a WebView bug. See MPS-112.
  <Select {...props} options={props.items} searchable={false} />
)

const mapStateToProps = (state, props) => {
  const configOptionValues = configStateSelector(state)[props.optionValuesConfigKey]
  return {
    items: props.optionBoundingSet.filter((option) => Object.values(configOptionValues ?? {}).includes(option.value)),
  }
}
export default connect<StoreProps, {}, OwnProps>(mapStateToProps)(DynamicSelect)
